const globalValueToBoolean = value => value === true || value === 'true';

export default () =>
	document.hidden &&
	!globalValueToBoolean(
		window?.ux_globals?.sysprops?.['sn_nxui_framework.scheduler.unchained.defer.off']
	) &&
	!globalValueToBoolean(
		window?.ux_globals?.nxui?.sysprops?.['sn_nxui_framework.scheduler.unchained.defer.off']
	);
